import { render, staticRenderFns } from "./shareUserCollection.vue?vue&type=template&id=c61ad24c&scoped=true&"
import script from "./shareUserCollection.vue?vue&type=script&lang=js&"
export * from "./shareUserCollection.vue?vue&type=script&lang=js&"
import style0 from "./shareUserCollection.vue?vue&type=style&index=0&id=c61ad24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61ad24c",
  null
  
)

export default component.exports